import { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const WholesaleForm = () => {
  const [formData, setFormData] = useState({
    company_name: '',
    contact_name: '',
    email: '',
    phone: '',
    country: '',
    business_type: '',
    annual_volume: '',
    meat_traditions: '',
    business_vision: ''
  });
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('');

    try {
      const response = await axios.post(`${BACKEND_URL}/api/wholesale`, formData);
      
      if (response.data.success) {
        setStatus('success');
        setFormData({
          company_name: '',
          contact_name: '',
          email: '',
          phone: '',
          country: '',
          business_type: '',
          annual_volume: '',
          meat_traditions: '',
          business_vision: ''
        });
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 md:p-12 shadow-lg space-y-6">
      {status === 'success' && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
          Thank you! Our wholesale team will contact you within 24 hours.
        </div>
      )}
      {status === 'error' && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          Sorry, there was an error. Please email us directly at info@originalbull.com
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Company Name *</label>
          <input 
            type="text"
            name="company_name"
            value={formData.company_name}
            onChange={handleChange}
            required 
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-700 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Contact Name *</label>
          <input 
            type="text"
            name="contact_name"
            value={formData.contact_name}
            onChange={handleChange}
            required 
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-700 focus:border-transparent"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
          <input 
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required 
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-700 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
          <input 
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-700 focus:border-transparent"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Country/Region *</label>
          <input 
            type="text"
            name="country"
            value={formData.country}
            onChange={handleChange}
            required 
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-700 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Business Type</label>
          <select 
            name="business_type"
            value={formData.business_type}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-700 focus:border-transparent"
          >
            <option value="">Select type</option>
            <option value="food_service">Food Service</option>
            <option value="retail_chain">Retail Chain</option>
            <option value="white_label">White Label</option>
            <option value="franchise">Franchise</option>
          </select>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Expected Annual Volume</label>
        <input 
          type="text"
          name="annual_volume"
          value={formData.annual_volume}
          onChange={handleChange}
          placeholder="e.g., 5000 kg/month"
          className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-700 focus:border-transparent"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Meat Tradition Requirements</label>
        <input 
          type="text"
          name="meat_traditions"
          value={formData.meat_traditions}
          onChange={handleChange}
          placeholder="e.g., Halal, Organic, etc."
          className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-700 focus:border-transparent"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Tell us about your business vision</label>
        <textarea 
          name="business_vision"
          value={formData.business_vision}
          onChange={handleChange}
          rows="5" 
          className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-700 focus:border-transparent"
        ></textarea>
      </div>

      <button 
        type="submit"
        disabled={isSubmitting}
        className="w-full bg-red-700 text-white px-6 py-4 rounded-md hover:bg-red-800 transition-colors font-medium text-lg disabled:bg-gray-400"
        data-testid="submit-partnership-btn"
      >
        {isSubmitting ? 'Submitting...' : 'Submit Partnership Inquiry'}
      </button>
    </form>
  );
};

export default WholesaleForm;
